// Classes & Types
import { useEffect, useState } from 'react';
import { Room, calculatePathColor } from '@breakroom-nx/classes';

// Components
import { Center, Box, Text } from 'native-base';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

export interface ChatAvatarProps {
  room: Room;
  size?: string | number;
}

export function ChatAvatar({ room, size = '70px' }: ChatAvatarProps) {
  const [, setTimeLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((tick) => tick + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box size={size} alignItems={'center'} alignContent={'center'}>
      <Center height={'full'} width={'full'}>
        <Box
          position={'absolute'}
          rounded={'full'}
          alignSelf={'center'}
          bg={room.theme}
          alignItems={'center'}
          justifyContent={'center'}
          size={'70%'}
        >
          <Text bg={'transparent'} fontSize={25}>
            {room.avatar}
          </Text>
        </Box>
        <CircularProgressbar
          value={room.timeLeft()}
          strokeWidth={6}
          styles={buildStyles({
            rotation: 0,
            strokeLinecap: 'round',
            pathTransitionDuration: 0.5,
            pathColor: calculatePathColor(room.timeLeft()),
            trailColor: 'transparent',
          })}
        />
      </Center>
    </Box>
  );
}

export default ChatAvatar;
